import React, { createContext, useMemo, useReducer } from 'react'
import PropTypes from 'prop-types'
import { EntityGraphReducer } from './EntityGraphReducer'

const initialState = {
  entityGraphId: null,
  styleEditItem: null,
  linkEditItem: null,
  displayAddNode: false,
  data: {
    edges: [],
    nodes: []
  },
  linkedEntityData: {},
  graphType: null,
  initialState: {
    data: {
      edges: [],
      nodes: []
    },
    canvasSettings: {}
  },
  config: {
    canvasSettings: {
      pathType: 'smoothstep',
      hideHandlers: false,
      nodesEditable: true,
      showToolbar: true
    },
    nodeCreation: {
      enabled: true,
      levels: ['account']
    },
    nodeLinking: {
      enabled: true,
      levels: ['account']
    }
  },
  stateHasChanged: false,
  levelTypeId: null,
  levelId: null
}

export const EntityGraphContext = createContext(initialState)

export const EntityGraphProvider = ({ children, ...props }) => {
  const mergedInitialState = {
    ...props,
    data: {
      ...initialState.data,
      ...(props?.data ?? {})
    },
    config: {
      ...initialState.config,
      ...(props?.config ?? {})
    }
  }

  const [state, dispatch] = useReducer(
    EntityGraphReducer,
    mergedInitialState,
    (props) => {
      const { config, data, ...state } = props
      return {
        ...state,
        stateHasChanged: false,
        initialState: {
          data,
          config
        },
        data: {
          ...initialState.data,
          ...(data ?? {})
        },
        config: {
          ...initialState.config,
          ...(config ?? {})
        }
      }
    })
  const value = useMemo(() => ({ state, dispatch }), [state])

  return (
    <EntityGraphContext.Provider value={value}>
      <div className='w-full'>
        {children}
      </div>
    </EntityGraphContext.Provider>
  )
}

EntityGraphProvider.propTypes = {
  children: PropTypes.node.isRequired,
  entityGraphId: PropTypes.number,
  data: PropTypes.shape({
    nodes: PropTypes.arrayOf(PropTypes.object),
    edges: PropTypes.arrayOf(PropTypes.object)
  }),
  linkedEntityData: PropTypes.object,
  graphType: PropTypes.string,
  config: PropTypes.shape({
    canvasSettings: PropTypes.shape({
      pathType: PropTypes.string,
      hideHandlers: PropTypes.bool,
      nodesEditable: PropTypes.bool
    }),
    nodeCreation: PropTypes.shape({
      enabled: PropTypes.bool,
      levels: PropTypes.arrayOf(PropTypes.string)
    }),
    nodeLinking: PropTypes.shape({
      enabled: PropTypes.bool,
      levels: PropTypes.arrayOf(PropTypes.string)
    })
  }),
  levelTypeId: PropTypes.number,
  levelId: PropTypes.number
}

export const useEntityGraphContext = () => {
  return React.useContext(EntityGraphContext)
}
